export const NO_ACCESS = 0;
export const READ_ONLY = 1;
export const FULL_ACCESS = 2;

export const TECHNICIAN = 10;
export const INSTALLER = 20;
export const RADIUS = 40;
export const RADIUS_ADMIN = 50;
export const CRUISE = 90;
export const RESELLER = 100;

export const getPermission = (link, role) => {
  if (link === 'users') {
    if (role === RADIUS_ADMIN) return FULL_ACCESS;
    return NO_ACCESS;
  }
  if (link === 'installer-rules') {
    if (role === RADIUS_ADMIN) return FULL_ACCESS;
    return NO_ACCESS;
  }
  if (link === 'installers') {
    if (role === RADIUS) return READ_ONLY;
    if (role === RADIUS_ADMIN) return FULL_ACCESS;
    return NO_ACCESS;
  }
  if (link === 'technicians') {
    if (role !== INSTALLER) return NO_ACCESS;
  }
  if (link === 'installer-users') {
    if (role !== INSTALLER) return NO_ACCESS;
  }
  if (link === 'installer-user/new') {
    if (role !== INSTALLER) return NO_ACCESS;
  }
  if (role === RADIUS) return READ_ONLY;
  if (role === RESELLER) return READ_ONLY;
  return FULL_ACCESS;
};



// WEBPACK FOOTER //
// ./src/permissions.js